var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "70 95 534.46 159.6",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.3,
    y: 219.11,
    width: 12.75,
    height: 35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.99,
    y: 243.22,
    width: 531.75,
    height: 10.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 591.76,
    y: 191.31,
    width: 12,
    height: 55.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.27,146.13c0-30.4,21.23-50.29,50.49-50.29,30,0,51.05,21,51.05,50.1s-21.22,49.34-48.95,49.34c-18,0-32.7-8.42-39.78-22.76v60.62H70.27Zm88.54-.57c0-21.8-15.3-37.86-37.86-37.86-22.76,0-37.87,16.06-37.87,37.86S98.19,183.42,121,183.42C143.51,183.42,158.81,167.36,158.81,145.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.9,146.13c0-29.45,21-50.29,50.86-50.29s50.68,20.46,50.68,50.29v46.66H272.58V169.46c-6.69,16.83-22.37,25.82-40.73,25.82C205.27,195.28,182.9,176.35,182.9,146.13Zm88.73-.57c0-21.8-15.3-37.86-37.87-37.86s-37.86,16.06-37.86,37.86,15.3,37.86,37.86,37.86S271.63,167.36,271.63,145.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M303.17,136.19c0-27.15,16.26-40.35,39.78-40.35s39.58,13.2,39.58,40.54v1.15H369.91v-1.34c0-19.7-10.9-28.49-27-28.49-16.26,0-27,8.79-27,28.49v56.6H303.17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M391.32,145.56c0-28.68,21-49.72,50.87-49.72,24.48,0,43,14.15,48.57,35.19h-13c-5.17-14.15-18.36-23.33-35.57-23.33-22.57,0-37.86,16.06-37.86,37.86s15.29,37.86,37.86,37.86c17.21,0,30.4-9.18,35.57-23.33h13c-5.55,21-24.09,35.19-48.57,35.19C412.36,195.28,391.32,174.24,391.32,145.56Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M502.23,146.13c0-29.45,21-50.29,50.86-50.29s50.68,20.46,50.68,50.29v46.66H591.91V169.46c-6.69,16.83-22.37,25.82-40.73,25.82C524.6,195.28,502.23,176.35,502.23,146.13Zm88.72-.57c0-21.8-15.29-37.86-37.86-37.86s-37.86,16.06-37.86,37.86,15.3,37.86,37.86,37.86S591,167.36,591,145.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ee038887aeea3642c6997ae0264c5a1.svg";
export { ForwardRef as ReactComponent };